module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAYUlEQVR42mNgQAIJCxj+k4sZqAFGHYBsYPU5whiXA/5nSg6sAwYkBEC+Jtvnow4YdcCwdwDRDhvSIUCVInvUAZQ4gCp1xqgD6OUAnNl1NApGHTDqgFEHjDpgUDmAVhjdTgBQfrwOO9a72QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_pluri_con.png
// module id = oaSB
// module chunks = 0